export interface ITicketGroupResponse {
    data: {
        id: number;
        name: string;
        description: string;
        isSuper: boolean;
        useCP: boolean;
        changeUsername: boolean;
        manageUsers: boolean;
        changePassword: boolean;
        editProfile: boolean;
        isCenter: boolean;
        addCenterUser: boolean;
        isLogisticsProvider: boolean;
        isXmKitVendor: boolean;
        isSerologyVendor: boolean;
        isRecipient: boolean;
        isDonor: boolean;
        isPhlebot: boolean;
        isNkrLab: boolean;
    }
}